// extracted by mini-css-extract-plugin
module.exports = {"default":"flying-btn_default__X_lTM","default_hide":"flying-btn_default_hide__2ebFZ","default_none":"flying-btn_default_none__3BPaT"};